<template>
    <div>
        <v-card elevation="0">
            <v-card-subtitle style="text-align:right;">
                <v-dialog v-model="dialogAddDep" persistent width="850">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn dark color="#CE93D8" v-bind="attrs" v-on="on" v-if="editPermission">Add Department</v-btn>
                    </template>
                    <v-card>
                        <v-toolbar color="#CE93D8" dark>
                            <v-toolbar-title>Add Department</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="dialogAddDep = false">
                                <v-icon>mdi-close-thick</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card elevation="0">
                            <v-card-text><br />
                                <v-text-field outlined label="Department Name" dense v-model="newdepname" @keydown="validateNewDep"></v-text-field>
                                <br />
                                <span class="text-body-1">Select Discipline&#40;s&#41; that are included in this Department: </span><br />
                                <span class="text-caption">Disciplines that are not in the list below are already configured in an Academic Department.</span><br />
                                <v-row v-if="dialogAddDep">
                                    <v-col cols="6" v-for="group in disciplinelist" :key="group">
                                        <v-row>
                                            <v-col cols="12" v-for="discipline in group" :key="discipline.value">
                                                <v-checkbox v-model="selectedDisciplineforNewDep" :label="discipline.label+' ('+discipline.value+')'" :value="discipline" hide-details></v-checkbox>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="#ECE3F0" :disabled="addbtnDisabled" @click="addDep" :loading="adddeploading">Add</v-btn>
                            </v-card-actions>
                        </v-card><br />
                    </v-card>
                </v-dialog>
            </v-card-subtitle>
            <v-row 
                class="fill-height"
                align-content="center"
                justify="center"
                v-if="dataLoading"
            >
                <v-container style="height: 450px;">
                    <v-row
                        class="fill-height"
                        align-content="center"
                        justify="center"
                    >
                        <v-col
                            class="text-subtitle-1 text-center"
                            cols="12"
                        >
                            Calling Department
                        </v-col>
                        <v-col cols="6">
                            <v-progress-linear
                                color="#CE93D8"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-container>
            </v-row>
            <v-card-text v-else>
                <v-expansion-panels>
                    <v-expansion-panel v-for="dep in depList" :key="dep.department">
                        <v-expansion-panel-header color="#ECE3F0" disable-icon-rotate>
                            {{ dep.department }}
                            <template v-slot:actions>
                                <v-icon @click="deleteDep(dep)" color="#FC2E20" v-if="deletePermission">mdi-trash-can-outline</v-icon>
                                <v-icon v-else>$expand</v-icon>
                            </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-card elevation="0">
                                <v-card-actions v-if="editPermission">
                                    <v-spacer></v-spacer>
                                    <v-btn color="#ECE3F0" @click="openEditDialog(dep)" small><v-icon>mdi-playlist-edit</v-icon>&nbsp;Edit</v-btn>
                                </v-card-actions>
                                <v-card-text class="font-weight-bold black--text">
                                    <v-row>
                                        <v-col cols="6" v-for="group in dep.display" :key="group">
                                            <v-row>
                                                <v-col cols="12" v-for="discipline in group" :key="discipline.value">
                                                    {{ discipline.name+' ('+discipline.value+')' }}
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialogDelete" width="500">
            <v-card>
                <v-toolbar color="#E56997" dark>Remove Department</v-toolbar>
                <br />
                <v-card-text>
                    Deleting this department &#40;<b> {{ selectedDep.department }} </b>&#41; will remove <b>ALL</b> subjects associated with the department.
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#3CACAE" text @click="dialogDelete = false" >
                        Cancel
                    </v-btn>
                    <v-btn color="#E56997" text @click="removeDepConfirm(selectedDep)" :loading="deleteloading">
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEditDiscipline" persistent width="850">
            <v-card>
                <v-toolbar color="#CE93D8" dark>
                    <v-toolbar-title>Update Discipline List for {{ selectedEditDep.department }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogEditDiscipline = false">
                        <v-icon>mdi-close-thick</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card elevation="0">
                    <v-card-text><br />
                        <v-row v-if="dialogEditDiscipline">
                            <v-col cols="6" v-for="group in selectedEditDep.display" :key="group">
                                <v-row>
                                    <v-col cols="12" v-for="discipline in group" :key="discipline.value">
                                        <v-checkbox v-model="selectedEditDep.config.subjects" :label="discipline.name+' ('+discipline.value+')'" :value="discipline" hide-details></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row><br />
                        <v-divider></v-divider>
                        <v-row v-if="dialogEditDiscipline">
                            <v-col cols="6" v-for="group in disciplinelist" :key="group">
                                <v-row>
                                    <v-col cols="12" v-for="discipline in group" :key="discipline.value">
                                        <v-checkbox v-model="selectedEditDep.config.subjects" :label="discipline.label+' ('+discipline.value+')'" :value="discipline" hide-details></v-checkbox>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="#ECE3F0" @click="editDisciplineList(selectedEditDep)" :loading="editloading">Update</v-btn>
                    </v-card-actions>
                </v-card><br />
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import auth from '@/js/auth';

export default {
    data(){
        return {
            editPermission: false,
            deletePermission: false,
            host: location.hostname.toString(),
            dataLoading: true,
            disciplinelist: [],
            takenDisciplinelist: [],
            selectedDisciplineforNewDep: [],
            dialogAddDep: false,
            newdepname: "",
            addbtnDisabled: true,
            depList: [],
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            panelvalue: false,
            dialogDelete: false,
            deleteloading: false,
            selectedDep: {},
            adddeploading: false,
            dialogEditDiscipline: false,
            selectedEditDep: {},
            editloading: false
        }
    },
    methods: {
        getPermissions(){
            const that = this;
            let permission = auth.get_permissions();

            if(permission.hasOwnProperty("setacademicdepartment")){
                if(permission.setacademicdepartment == 1){
                    that.editPermission = true;
                }else {
                    that.editPermission = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.editPermission = true;
            }else {
                that.editPermission = false;
            }

            if(permission.hasOwnProperty("deleteacademicdepartment")){
                if(permission.deleteacademicdepartment == 1){
                    that.deletePermission = true;
                }else {
                    that.deletePermission = false;
                }
            }else if(permission.hasOwnProperty("rootgroup")){
                that.deletePermission = true;
            }else {
                that.deletePermission = false;
            }
        },
        getDisciplineList(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getsubjects';
            that.disciplinelist = [];
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            var checkedArray = [];
                            var dividedArray = [];
                            json.data.forEach(element => {
                                element["configured"] = false;
                                that.takenDisciplinelist.forEach(ele => {
                                    if(JSON.stringify(ele) == JSON.stringify({"name": element["label"], "value": element["value"]})){
                                        element["configured"] = true;
                                    }
                                });

                                checkedArray.push(element);
                            });

                            checkedArray.forEach(item => {
                                if(item["configured"] == false){
                                    dividedArray.push({"label": item["label"], "value": item["value"]});
                                }
                            });

                            let mid = Math.ceil(dividedArray.length / 2);

                            for(let col = 0; col < 2 ; col++){
                                that.disciplinelist.push(dividedArray.slice(col*mid, col*mid+mid));
                            }
                        }
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
        },
        getDepartmentList(){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=getacademicdepartments';
            that.dataLoading = true;
            that.takenDisciplinelist = [];
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        if(json.data.length > 0){
                            that.depList = json.data;
                            json.data.forEach(element => {
                                that.takenDisciplinelist = [...that.takenDisciplinelist, ...element["config"]["subjects"]];
                                element["display"] = [];
                                let mid = Math.ceil(element["config"]["subjects"].length / 2)
                                for(let col = 0; col < 2 ; col++){
                                    element["display"].push(element["config"]["subjects"].slice(col*mid, col*mid+mid));
                                }
                            });
                        }else {
                            that.depList = [];
                        }
                        
                        that.getDisciplineList();
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                    
                    that.dataLoading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    
                    that.dataLoading = false;
                })
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
        validateNewDep(){
            const that = this;

            if(that.newdepname.length>0){
                that.addbtnDisabled = false;
            }else {
                that.addbtnDisabled = true;
            }
        },
        addDep(){
            const that = this;
            that.adddeploading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

            let disciplines = [];
            that.selectedDisciplineforNewDep.forEach(element => {
                disciplines.push({"name": element["label"], "value": element["value"]})
            });

            let depData = {
                "department" : that.newdepname,
                "subjects" : disciplines
            }

            const formData = new FormData();

            formData.append("mode", "setacademicdepartment");
            formData.append("data", JSON.stringify(depData));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Successfully added Department "+that.newdepname, "#388E3C"); //green
                        that.getDepartmentList();
                        that.newdepname = "";
                        that.selectedDisciplineforNewDep = [];
                        that.dialogAddDep = false;
                    }

                    that.adddeploading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.adddeploading = false;
                })
            //End of API calling
        },
        deleteDep(dep){
            const that= this;
            that.selectedDep = dep;
            that.dialogDelete = true;
        },
        removeDepConfirm(dep){
            const that = this;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=deleteacademicdepartment&data={"department": "'+dep.department+'"}';
            that.deleteloading = true;
            // GET request
            fetch(api)
                .then(function (response) {
                    // Return json response
                    return response.json();
                })
                .then(function (json) {
                    if (json.result.match(/^OK/i)) {
                        that.setSnackbar(json.message, "green");
                        that.getDepartmentList();
                        that.dialogDelete = false;
                    }else {
                        that.setSnackbar("Warning: "+json.message, "#EF6C00"); //orange
                    }
                    
                    that.deleteloading = false;
                })
                .catch(function (err) {
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    
                    that.deleteloading = false;
                })

            that.dialogDelete = false;
        },
        openEditDialog(dep){
            const that = this;
            that.selectedEditDep = dep;
            that.dialogEditDiscipline = true;
        },
        editDisciplineList(dep){
            const that = this;

            that.editloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

            let disciplines = [];
            dep.config.subjects.forEach(element => {
                if(element.hasOwnProperty("label")){
                    disciplines.push({"name": element["label"], "value": element["value"]})
                }else {
                    disciplines.push({"name": element["name"], "value": element["value"]})
                }
            });

            let depData = {
                "id" : dep.id,
                "subjects" : disciplines
            }

            const formData = new FormData();

            formData.append("mode", "setacademicdepartment");
            formData.append("data", JSON.stringify(depData));

            //API calling
            fetch(api,{
                    method: "POST",
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.setSnackbar("Successfully Updated Department "+dep.department, "#388E3C"); //green
                        that.getDepartmentList();
                        that.dialogEditDiscipline = false;
                        that.selectedEditDep = {};
                    }

                    that.editloading = false;
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                    that.editloading = false;
                })
            //End of API calling
        }
    },
    created(){
        const that = this;
        that.getPermissions();
        that.getDepartmentList();
    }
}
</script>
